"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectAllContext = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
const SelectAllContext = (0, _lodestarUtils.createContext)({
  // Default to false so this is not enabled in single select.
  enabled: false,
  getText: () => ""
}, "SelectAllContext");
exports.SelectAllContext = SelectAllContext;
//# sourceMappingURL=SelectAllContext.js.map